import { render, staticRenderFns } from "./outsourcing.vue?vue&type=template&id=87e669a2&scoped=true"
import script from "./outsourcing.vue?vue&type=script&lang=js"
export * from "./outsourcing.vue?vue&type=script&lang=js"
import style0 from "./outsourcing.vue?vue&type=style&index=0&id=87e669a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e669a2",
  null
  
)

export default component.exports